import NextLink from "next/link";
import { LinkIcon } from "styles/icons";
import {
  ChakraLink as Link,
  ChakraText as Text,
  ChakraList as List,
  ChakraListItem as ListItem,
} from "@airhelp/react-ui-components";

interface ListItemTypes {
  url: string;
  anchorText: string;
}

interface LinkBoxProps {
  linkItems: ListItemTypes[];
}

const LinkBox = ({ linkItems }: LinkBoxProps) => (
  <List>
    {linkItems.map(({ url, anchorText }) => (
      <ListItem key={url} my={2}>
        <Link as={NextLink} href={url} passHref color="primary.500" fontSize="lg" display="flex" alignItems="center">
          <LinkIcon />
          <Text ml={4}>{anchorText}</Text>
        </Link>
      </ListItem>
    ))}
  </List>
);

export default LinkBox;
